import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageEnum } from 'src/app/enums/language.enum';
import { TranslateService } from 'src/app/services/translate.service';

@Component({
  standalone: false,
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent {
  dropdownOpen = false;
  languageKeys: (keyof typeof LanguageEnum)[] = [];
  selectedLanguageLabel: string;

  constructor(private translateService: TranslateService) {
    this.languageKeys = this.translateService.getLanguageList();
    this.selectedLanguageLabel = this.translateService.getSelectedLanguageLabel();
  }

  toggleDropdown(close = false): void {
    this.dropdownOpen = close ? false : !this.dropdownOpen;
  }

  switchLanguage(languageKey: keyof typeof LanguageEnum): void {
    this.selectedLanguageLabel = languageKey;
    this.translateService.changeLanguage(LanguageEnum[languageKey]);
    this.dropdownOpen = false;
  }

    public trackByIndex = trackByIndex;
}
